// React
import React from 'react';
import { Controller } from 'react-hook-form';
// material-ui components
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
// custom components
import NumberedHeading from "../../../../../shared-components/forms/NumberedHeading";
import ImageAttribution from '../shared/ImageAttribution';
import WYSIWYGEditor from "../../../../../shared-components/WYSIWYGEditor";
import MaterialsArray from './components/MaterialsArray';

const PECapstonePresentationBrief = (props) => {

  const { control, formState } = props.methods;
  const { errors } = formState;

  const { inputDir } = props;

  return (
    <div>
      <NumberedHeading number="1" title="PPT Title (Slide 1)" instructions="What is the title for the PPT?" />
      <Controller
        control={control}
        name="content.ppt_title"
        render={({ field }) => (
          <TextField
            className="mt-16"
            {...field}
            label="PPT Title"
            placeholder="PPT Title"
            error={!!errors.content?.ppt_title}
            helperText={errors.content?.ppt_title?.message}
            variant="outlined"  
            fullWidth
            required
            dir={inputDir}
          />
        )}
      />

      <Divider className="my-16" />

      <NumberedHeading number="2" title="PPT Image (Slide 1)" instructions="Provide an Image to be used with the title slide." />
      <Controller 
        control={control}
        name="content.media"
        render={({ field }) => <ImageAttribution targetObj="content.media" inputDir={inputDir} errors={errors.content?.media} {...{control }} />}
      />

      <Divider className="my-16" />

      <NumberedHeading number="3" title="Prompt (TL) (Slide 2)" instructions="What is the constructed response prompt (in the Target Language)?" />
      <Controller
        control={control}
        name="content.prompt_tl"
        render={({ field }) => <WYSIWYGEditor {...field} error={errors.content?.prompt_tl} />}
      />

      <Divider className="my-16" />

      <NumberedHeading number="4" title="Prompt (EN) (Slide 2)" instructions="What is the constructed response prompt (in English)?" />
      <Controller
        control={control}
        name="content.prompt_en"
        render={({ field }) => <WYSIWYGEditor {...field} error={errors.content?.prompt_en} />}
      />

      <Divider className="my-16" />

      <NumberedHeading number="5" title="Key Points (TL) (Slide 3)" instructions="What are the key points (in the Target Language)?" />
      <Controller
        control={control}
        name="content.key_points_tl"
        render={({ field }) => <WYSIWYGEditor {...field} error={errors.content?.key_points_tl} />}
      />

      <Divider className="my-16" />

      <NumberedHeading number="6" title="Key Points (EN) (Slide 3)" instructions="What are the key points (in English)?" />
      <Controller
        control={control}
        name="content.key_points_en"
        render={({ field }) => <WYSIWYGEditor {...field} error={errors.content?.key_points_en} />}
      />

      <Divider className="my-16" />

      <NumberedHeading number="7" title="Schoolhouse Answer Instruction (TL) (Slide 4)" instructions="What is the instruction/context provided along with the Schoolhouse Response? (in the Target Language)" />
      <Controller
        control={control}
        name="content.sa_ins_tl"
        render={({ field }) => <WYSIWYGEditor {...field} error={errors.content?.sa_ins_tl} />}
      />

      <Divider className="my-16" />

      <NumberedHeading number="8" title="Schoolhouse Answer Instruction (EN) (Slide 4)" instructions="What is the instruction/context provided along with the Schoolhouse Response? (in English)?" />
      <Controller
        control={control}
        name="content.sa_ins_en"
        render={({ field }) => <WYSIWYGEditor {...field} error={errors.content?.sa_ins_en} />}
      />

      <Divider className="my-16" />

      <NumberedHeading number="9" title="Response (Slide 4)" instructions="Write the schoolhouse response that will be shown to the student to let them know what their response could have looked like." />
      <Controller
        control={control}
        name="content.response"
        render={({ field }) => <WYSIWYGEditor {...field} error={errors.content?.response} />}
      />

    </div>
  );
};

export default PECapstonePresentationBrief;